exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/eveasoft/lea/lea-front/src/app/core/layout/sidebar/userblock/userblock.component.scss
// module id = ../../../../../src/app/core/layout/sidebar/userblock/userblock.component.scss
// module chunks = main